/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
// react-bootstrap components
import { Container, Row, Col } from "react-bootstrap";

import { useSelector } from "react-redux";
import styled from "styled-components";
import { useHistory, useLocation } from "react-router-dom";
import TabMaterialLog from "../../../../components/organisms/tabs-material/TabMaterialLog";
import { Tab, Tabs } from "@material-ui/core";
import queryString from "query-string";
import PostulatesTravels from "./Postulates";
import Index from "./InActions/Index";
import FinishedTC from "./Finished/FinishedTC";
import PendingTc from "./Pendings/PendingTc";

const DivParentTabs = styled.div`
  border-bottom: 1px solid #d1d0d0;
`;
const TabsStyled = styled(Tabs)`
  width: 90%;
  margin: 0px 30px;
  @media (max-width: 991px) {
    width: 100%;
    margin: 0px;
    margin-right: 10px;
  }
`;

const TabStyled = styled(Tab)`
  span {
    font-size: 18px;
    font-weight: bolder !important;
  }
`;

function Travels() {
  const id = useSelector((state) => state.authApp.user._id);
  const history = useHistory();
  const location = useLocation();
  // eslint-disable-next-line no-unused-vars
  const [trips, setTrips] = useState([]);
  const [value, setValue] = React.useState(false);

  useEffect(() => {}, []);

  useEffect(() => {
    const { state } = queryString.parse(location.search);
    setValue(parseInt(state || 0));
  }, [location]);

  /* useEffect(() => {
    history.push(`/app/my-travels-tc?state=${value}`);
  }, [value]); */

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const handleChange = (event, newValue) => {
    history.push(`/app/my-travels-tc?state=${newValue}`);
    setValue(newValue);
  };
  return (
    <>
      <DivParentTabs>
        <TabsStyled
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          aria-label="simple tabs example"
          scrollButtons="off"
          variant="scrollable"
        >
          <TabStyled label="Viajes postulados" {...a11yProps(0)} />
          <TabStyled label="Postulaciones canceladas" {...a11yProps(1)} />
          <TabStyled label="Viajes pendientes" {...a11yProps(2)} />
          <TabStyled label="En ejecución" {...a11yProps(3)} />
          <TabStyled label="Finalizados" {...a11yProps(4)} />
        </TabsStyled>
      </DivParentTabs>
      <Container fluid>
        <Row>
          <Col md="12">
            <TabMaterialLog value={value} index={0}>
              <PostulatesTravels state={"0"} />
            </TabMaterialLog>
            <TabMaterialLog value={value} index={1}>
              <PostulatesTravels state={2} />
            </TabMaterialLog>
            <TabMaterialLog value={value} index={2}>
              <PendingTc />
            </TabMaterialLog>
            <TabMaterialLog value={value} index={3}>
              <Index></Index>
            </TabMaterialLog>
            <TabMaterialLog value={value} index={4}>
              <FinishedTC />
            </TabMaterialLog>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Travels;
